enum LAYOUT_TYPES {
  DEFAULT = 'DEFAULT',
  CAROUSEL = 'CAROUSEL',
  CENTER = 'CENTER',
  TAB_CAROUSEL = 'TAB_CAROUSEL',
  TOP = 'TOP',
  TOP_LEFT = 'TOP_LEFT',
  TOP_RIGHT = 'TOP_RIGHT',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  BOTTOM = 'BOTTOM',
  BOTTOM_LEFT = 'BOTTOM_LEFT',
  BOTTOM_RIGHT = 'BOTTOM_RIGHT',
  NON_OVERLAY = 'NON_OVERLAY',
  REVIEW_SLIDER = 'REVIEW_SLIDER',
  RICH_TEXT_WITH_SUBTEXT = 'RICH_TEXT_WITH_SUBTEXT',
  UNI_ROW = 'UNI_ROW',
  UNI_ROW_FLIP = 'UNI_ROW_FLIP',
  RICH_TEXT_WITHOUT_BOTTOM_BORDER = 'RICH_TEXT_WITHOUT_BOTTOM_BORDER',
  OPTIMISED_VIDEO = 'OPTIMISED_VIDEO',
}

export default LAYOUT_TYPES
